// hooks/useAuthenticationData.js

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestgetcurrenctuser, requestGetMyTeam } from "../../Store/User/action";
import { handleRequestGetAllClientData } from "../../Store/Internationalise/action";
import { handleRequestGetAllLookup } from "../../Store/lookup/action";
import { requestGetTelecallingDetails } from "../../Store/Telecalling/action";
import { requestGetAllTextfieldDetails } from "../../Store/Customization/action";
import { teampermissionList } from "../../Utility/constant";

export const useAuthenticationData = () => {
    const dispatch = useDispatch();

    const token = localStorage.getItem("accessToken");
    const currentUser = useSelector(state => state?.owner?.currentuser);

useEffect(() => {
    if (!token) return;

    if (!currentUser) {
        dispatch(requestgetcurrenctuser(token));
    }
}, []); 

useEffect(() => {
    if (!currentUser?.client?.id || currentUser?.resetPassword === true) return;

    dispatch(handleRequestGetAllClientData(currentUser.client.id, true));
    dispatch(handleRequestGetAllLookup(token, currentUser.client.id));
    // dispatch(requestGetAllMerchant());
    // dispatch(requestGetAllCustomers());
    dispatch(requestGetTelecallingDetails());
    dispatch(requestGetAllTextfieldDetails());
}, [dispatch, currentUser?.client?.id, currentUser?.resetPassword]);

useEffect(() => {
    if (!currentUser?.userId || currentUser?.resetPassword === true) return;

    const isRequired = currentUser.authorities?.some(item =>
        teampermissionList.includes(item.authority)
    );

    if (isRequired) {
        dispatch(requestGetMyTeam(currentUser.userId));
    }
}, [dispatch, currentUser?.userId, currentUser?.authorities, currentUser?.resetPassword]);

};